import './style.scss'

import { Route, Switch } from 'react-router-dom'

import ClubsApp from '../../apps/soccer/Clubs/ClubsApp'
import CompetitionsApp from '../../apps/soccer/Competitions/CompetitionsApp'
import CompetitionApp from '../../apps/soccer/Competition/CompetitionApp'
import MembersApp from '../../apps/soccer/Members/MembersApp'
import OldBeforeGamesView from '../../apps/soccer/OldBeforeGames/OldBeforeGamesView'
import OldPlayersView from '../../apps/soccer/OldClubs/OldPlayersView'
import OldTeamsView from '../../apps/soccer/OldClubs/OldTeamsView'
import OrganizationApp from '../../apps/soccer/Organization/OrganizationApp'
import React from 'react'
import SitesApp from '../../apps/soccer/Sites/SitesApp'
import SponsorsApp from '../../apps/soccer/Sponsors/SponsorsApp'

const SoccerView = () => {
  return (
    <Switch>
      <Route path="/soccer/members/">
        <MembersApp />
      </Route>
      <Route path="/soccer/clubs/">
        <ClubsApp />
      </Route>
      <Route path="/soccer/competitions/">
        <CompetitionsApp/>
      </Route>
      <Route path="/soccer/competition/:competition_id">
        <CompetitionApp/>
      </Route>
      <Route path="/soccer/sites/">
        <SitesApp />
      </Route>
      <Route path="/soccer/organization/">
        <OrganizationApp />
      </Route>
      <Route path="/soccer/sponsors/">
        <SponsorsApp />
      </Route>
      <Route exact path="/soccer/old/games">
        <OldBeforeGamesView />
      </Route>
      <Route exact path="/soccer/old/teams">
        <OldTeamsView />
      </Route>
      <Route exact path="/soccer/old/teams/:teamId/players">
        <OldPlayersView />
      </Route>
    </Switch>
  )
}

export default SoccerView